<app-header></app-header>
<div class="contenedor_principal">
    <app-menu-alterno></app-menu-alterno>
    <div class="div-contenido-titulo-2">
        <div class="div-cuadro-busqueda"><input #myInput type="text" id="myInput" (keyup)="buscarPalabra(myInput.value)"
                (keyup.enter)="buscarPalabra(myInput.value)" class="input-text" placeholder="Buscar en boletines"
                title="Escriba una palabra clave"><input class="input-button" type="image"
                src="./assets/img/iconos/search.png" (click)="buscarPalabra(myInput.value)" /></div>

        <div class="div-titulo-seccion">
            <h1 class="h1-titulo-app">{{constante.ETIQUETA_BOTON_BOLETINES}}</h1>
        </div>
    </div>
    <div class="div-linea-titulo"></div>
    <div id="accordion" class="opcion-menu-accordion ui-accordion ui-widget ui-helper-reset" role="tablist">



        <cdk-accordion class="accordion-container">
            <cdk-accordion-item *ngFor="let dato of listaDataAccordionFiltro; let index=index;"
                [expanded]="dato.expanded" #accordionItem="cdkAccordionItem" role="button" tabindex="0"
                [attr.id]="'accordion-header-' + index" [attr.aria-expanded]="accordionItem.expanded"
                [attr.aria-controls]="'accordion-body-' + index">
                <div class="accordion-item-header {{accordionItem.expanded ? 'is-active' : 'not-active'}}"
                    (click)="accordionItem.toggle()">
                    {{ dato.nombre }}
                    <mat-icon *ngIf="!accordionItem.expanded" class="mat-icon-add">add</mat-icon>
                    <mat-icon *ngIf="accordionItem.expanded" class="mat-icon-remove">remove</mat-icon>
                </div>
                <div class="opcion-submenu-accordion" role="region"
                    [style.display]="accordionItem.expanded ? '' : 'none'" [attr.id]="'accordion-body-' + index"
                    [attr.aria-labelledby]="'accordion-header-' + index">
                    <cdk-accordion class="accordion-sub-container">
                        <cdk-accordion-item *ngFor="let hijo of dato.menuHijos; let idiceHijo=index;"
                            [expanded]="hijo.expanded" #accordionSubItem="cdkAccordionItem" role="button" tabindex="0"
                            id="{{hijo.id}}" [attr.id]="'accordion-header-' + hijo.id"
                            [attr.aria-expanded]="accordionSubItem.expanded"
                            [attr.aria-controls]="'accordion-body-' + index">
                            <div class="accordion-sub-item-header {{accordionSubItem.expanded ? 'is-active' : 'not-active'}}"
                                (click)="accordionSubItem.toggle(); cerrarOpcionesHijas(hijo)">
                                <span [innerHTML]="hijo.nombre"></span>
                                <mat-icon *ngIf="!accordionSubItem.expanded" class="mat-icon-add">add</mat-icon>
                                <mat-icon *ngIf="accordionSubItem.expanded" class="mat-icon-remove">remove</mat-icon>
                            </div>
                            <div role="region" [style.display]="accordionSubItem.expanded ? '' : 'none'"
                                [attr.id]="'accordion-body-' + index"
                                [attr.aria-labelledby]="'accordion-header-' + index">
                                <mat-expansion-panel expanded *ngIf="hijo.definicion != '' && hijo.definicion != '-'">
                                    <mat-expansion-panel-header> 
                                        <mat-panel-title> Descripción </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <div class="div-definicion"><span [innerHTML]="hijo.definicion"></span></div>
                                </mat-expansion-panel>

                                <div *ngFor="let nieto of hijo.menuHijos; let idiceHijo=index;">
                                    <div class="div-titulo">
                                        <table class="tabla-catalogo" id="table_{{nieto.nombre}}_{{nieto.id}}"
                                            (click)="desplegarTabla(nieto, hijo)">
                                            <tbody>
                                                <tr>
                                                    <th>
                                                        <mat-icon class="icono-mas-menos"
                                                            id="span_icon_{{nieto.nombre}}_{{nieto.id}}">{{nieto.iconDisplay}}</mat-icon>
                                                        <span [innerHTML]="nieto.nombre"></span>
                                                        <section id="section_{{nieto.nombre}}_{{nieto.id}}"></section>
                                                    </th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="contenedor-tabla" id="div_tabla_{{nieto.nombre}}_{{nieto.id}}"
                                        [style.display]="nieto.display ? 'block' : 'none'">
                                        <div *ngIf="nieto.informacionSerie != null" id="tblNeedsScrolling"
                                            class="detalle-serie-tabla div-contenido">
                                            <div *ngIf="listaNotasNM.length>0">
                                                <div class="div-notas">
                                                    <ul *ngFor="let nota of listaNotasNM" class="ul-lista-enlace-guia">
                                                        <li>
                                                            <span *ngIf="nota.nombreAdjunto == ''"
                                                                [innerHTML]="nota.descripcion"
                                                                class="p-descripcion"></span>
                                                            <a *ngIf="nota.nombreAdjunto != ''"
                                                                (click)="abrirEnlace(nota)"
                                                                class="a-link-download-file">
                                                                {{nota.descripcion}} </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </cdk-accordion-item>
                    </cdk-accordion>
                </div>
            </cdk-accordion-item>
        </cdk-accordion>
    </div>
</div>